import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "fill-height dashboards-wrapper",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "fullscreen"
  }, [_c('iframe', {
    staticClass: "db-iframe",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.dburl
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };